import React from 'react';
import { BrandIconSpinnerContainer } from './Component.style';
import { ReactComponent as WafyNetLogo } from 'assert/images/Common/wafynetLogo.svg';

const BrandIconSpinner = ({ customStyle, loading }) => {
  if (!loading) return null;
  return (
    <BrandIconSpinnerContainer className={customStyle}>
      <div className="loader-content">
        <WafyNetLogo />
        <div className="loader"></div>
      </div>
    </BrandIconSpinnerContainer>
  );
};

export default BrandIconSpinner;
